// extracted by mini-css-extract-plugin
module.exports = {"emailSentWrapper":"EmailSent_emailSentWrapper__SZ2t3","emailSent":"EmailSent_emailSent__2f6Dz","followSent":"EmailSent_followSent__3G35T"};